import React from 'react';

import Logo from '../../Common/components/Logo';
import images from '../../Common/Images';

import LocalizedStrings from 'react-localization';
import {translations} from "../../Common/Translations";
import localStorage from '../../Common/LocalStorage';

let strings = new LocalizedStrings(translations);

const ForgottenPassword = props => {

    const emailAlert = (valid, errorMsg) => (valid ? null : <div className="Error-message">{errorMsg}</div>);

    const clickHandler = () => {
        props.sendMailHander();
    };

    const pressHandler = e => {
        if (e.key === 'Enter') {
            props.sendMailHander();
        }
    };

    if (localStorage.getFromStorage('lang') === undefined) {
        localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
    }

    strings.setLanguage(localStorage.getFromStorage('lang'));

    return (
        <div className="container">
            <div className="login-container row" onKeyPress={pressHandler}>
                <div className="col-6 offset-3">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="logo">
                                <Logo url={images.LOGIN_LOGO}/>
                            </div>
                        </div>
                        <div className="col-12 text-center">
                            <h1 className="login-title">{strings.forgotten_password}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 qf-mb-30">
                            <div className="form-container">
                                <input
                                    className="email-input input"
                                    id="email"
                                    type="text"
                                    placeholder={strings.enter_email}
                                    onChange={props.updateEmail}
                                />

                                {emailAlert(props.validEmail, props.emailErrorMsg)}

                                <div onClick={props.emailValidation}>
                                    <input className="send-button input" id="send" value={strings.send} type="submit"
                                           onClick={clickHandler}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgottenPassword;



// WEBPACK FOOTER //
// ./src/customModules/Login/components/Forgotten-password-login.js